export default __webpack_public_path__ + "static/char-s-57-zh-Hans-588dfb07726e19b9b2ae51b6dc50adf1.webp";